export const BLUEGRAY = '#427175';
export const ORANGE = '#f49542';
export const ORANGEDARK = '#b54711';
export const ORANGELIGHT = '#f49542';
export const RED = '#D84315';
export const DARKRED = '#840000';
export const PURPLE = '#9743db';
export const GREEN = '#689F38';
export const VIOLET = '#673ab7';
export const VIOLET2 = '#8270a4';
export const GRAY = '#636363';
export const LIGHTRED = '#ff4f4f';
export const DARKBLUE = '#3a4571';
export const BLUE = '#0277BD';
export const LIGHTBLUE = '#7986CB';
export const LIGHTBLUETRANSP = 'rgba(135, 152, 218, 0.8)';
export const PLASTICGREEN = '#008290';
export const LIGHTGRAY = '#778899';
export const YELLOW = '#ffd700';
export const LIGHTBROWN = '#cd9b9b';
export const SALATGREEN = '#7cfc00';
export const LIGHTYELLOW = '#fff68f';
export const BROWN = '#8b4513';
export const LIGHTGREEN = '#caff70';
export const DARKGRAY = '#8b8878';
export const LIGHTLIGHTGRAY = '#d3d3d3';

export const ORANGE100 = '#FFE0B2'; 
export const ORANGE200 = '#FFCC80'; 
export const ORANGE300 = '#FFB74D'; 
export const ORANGE400 = '#FFA726'; 
export const ORANGE500 = '#FF9800'; 
export const ORANGE600 = '#FB8C00'; 
export const ORANGE700 = '#F57C00'; 

export const LIGHTBLUE200 = '#81D4FA';
export const LIGHTBLUE500 = '#03A9F4';
export const LIGHTBLUE800 = '#0277BD';

export const CYAN200 = '#80DEEA';
export const CYAN500 = '#00BCD4';
export const CYAN800 = '#00838F';
export const CYAN900 = '#006064';

export const TEAL200 = '#80CBC4';
export const TEAL500 = '#009688';
export const TEAL800 = '#00695C';

export const LIGHTGREEN300 = '#AED581';

export const BLUEGREEN1 = 'rgb(66, 113, 117)';
export const BLUEGREEN2 = 'rgb(0, 130, 144)';
export const BLUE1 = 'rgb(2, 119, 189)';
export const GREEN1 = 'rgb(76, 176, 80)';
export const GREEN2 = 'rgb(0, 151, 136)';

export const GREY200 = '#EEEEEE';
export const GREY300 = '#E0E0E0';


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/colors.js